import React from 'react'

function GoBack({ goBack, step }) {
    return (
            <button onClick={() => goBack(step)} className="btn btn-primary bck_btn" type="button">Back</button>
    )
}

export default GoBack
